import { useTranslation } from "react-i18next";
import { CONTACT_EMAIL, LINKEDIN_URL, YOUTUBE_URL, FACEBOOK_URL } from "../../constants/links";
import { EmailIcon, FacebookIcon, LinkedInIcon, YouTubeIcon } from "../icons/SocialMediaIcons";

function ContactSection() {
  const { t } = useTranslation();

  return (
    <section className="homeSection homeSection--muted" id="contact">
      <div className="homeSection__inner">
        <div className="homeSection__header">
          <p className="homeSection__eyebrow">{t("home.contactUs.eyebrow")}</p>

          <h2 className="homeSection__title">{t("home.contactUs.title")}</h2>

          <p className="homeSection__subtitle">{t("home.contactUs.subtitle")}</p>
        </div>

        <div className="contactGrid">
          {/* EMAIL */}
          <div className="contactCard contactCard--email">
            <div className="contactCard__icon">
              <EmailIcon />
            </div>

            <div>
              <h3 className="contactCard__title">Email</h3>

              <a
                href={`mailto:${CONTACT_EMAIL}`}
                onClick={(e) => {
                  window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${CONTACT_EMAIL}`);
                  e.preventDefault();
                }}
                className="contactCard__link"
              >
                {CONTACT_EMAIL}
              </a>
            </div>
          </div>

          {/* LINKEDIN */}
          <div className="contactCard contactCard--linkedin">
            <div className="contactCard__icon">
              <LinkedInIcon />
            </div>

            <div>
              <h3 className="contactCard__title">LinkedIn</h3>

              <a href={LINKEDIN_URL} target="_blank" rel="noreferrer" className="contactCard__link">
                {t("home.contactUs.linkedIn")}
              </a>
            </div>
          </div>

          {/* YOUTUBE */}
          <div className="contactCard contactCard--youtube">
            <div className="contactCard__icon">
              <YouTubeIcon />
            </div>

            <div>
              <h3 className="contactCard__title">YouTube</h3>

              <a href={YOUTUBE_URL} target="_blank" rel="noreferrer" className="contactCard__link">
                {t("home.contactUs.youtube")}
              </a>
            </div>
          </div>

          {/* FACEBOOK (NEW) */}
          <div className="contactCard contactCard--facebook">
            <div className="contactCard__icon">
              <FacebookIcon />
            </div>

            <div>
              <h3 className="contactCard__title">Facebook</h3>

              <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" className="contactCard__link">
                {t("home.contactUs.facebook") || "Visit Facebook Page"}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
